'use strict';

import { Company } from '../Company';
import { Entity } from '../Entity';
import { Plan } from '../Plan';
import { User } from './User';

import { UserCommissionSchedule } from './UserCommissionSchedule';

export class UserCommissionScheduleBand extends Entity {
  protected id: number;
  protected schedule: UserCommissionSchedule;
  protected position: number;
  protected yearMin: number;
  protected yearMax: number;
  protected value: number;

  constructor() {
    super();
  }

  public hydrate(data: any) {
    this.id = data.id;
    this.position = data.position;
    this.yearMin = data.yearMin;
    this.yearMax = data.yearMax;
    this.value = data.value;

    if (data.schedule) {
      const schedule = new UserCommissionSchedule();
      schedule.hydrate(data.schedule);

      this.schedule = schedule;
    }
  }

  public getId() {
    return this.id;
  }

  public getSchedule() {
    return this.schedule;
  }

  public getPosition() {
    return this.position;
  }

  public getYearMin() {
    return this.yearMin;
  }

  public getYearMax() {
    return this.yearMax;
  }

  public getValue() {
    return this.value;
  }
}
